/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { apiUrl, headerconfig } from "../Settings/Config";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "products/";
var moduleName = "Product";
const Warranty = [
  { value: "OUT OF WARRANTY", label: "OUT OF WARRANTY" },
  { value: "SPOT", label: "SPOT" },
  { value: "BUYBACK", label: "BUYBACK" },
  { value: "ATS", label: "ATS" },
  { value: "CSMC", label: "CSMC" },
  { value: "ACSMC", label: "ACSMC" },
  { value: "AMC", label: "AMC" },
];
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID;
    this.state = {
      editID:
        editID !== "" &&
        typeof editID !== undefined &&
        typeof editID !== "undefined"
          ? editID
          : "",
      userID: userID(),
      postdata: {
        productName: "",
        productbrandID: "",
        productMachineNo: "",
        productModleNo: "",
        productHSNSAC: "",
        productTax: "",
        productStock: "",
        productPrice: "",
        amcPrice: "",
        cmcPrice: "",
        productWarrantyPeriod: "",
        status: "",
      },
      brandList: [],
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadBrand();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var productStatus =
            result.productStatus === "A" ? "Active" : "In Active";
          var status =
            result.productStatus !== "" && result.productStatus !== null
              ? {
                  label: productStatus,
                  value: result.productStatus,
                }
              : "";
          var productTax = '';
          if(result.productTax==='18.00') {
            productTax = {label:'18%', value:'18.00'};
          }else if(result.productTax==='28.00') {
            productTax = {label:'28%', value:'28.00'};
          }
          
          var clientupdatedata = {
            productName: result.productName,
            productbrandID: result.brand,
            productModleNo: result.productModleNo,
            productMachineNo: result.productMachineNo,
            productHSNSAC: result.productHSNSAC,
            productTax: productTax,
            productStock: result.productStock,
            productPrice: result.productPrice,
            amcPrice: result.amcPrice,
            cmcPrice: result.cmcPrice,
            productWarrantyPeriod:
              result.productWarrantyPeriod !== "" &&
              result.productWarrantyPeriod !== null
                ? {
                    label: result.productWarrantyPeriod,
                    value: result.productWarrantyPeriod,
                  }
                : "",
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadBrand() {
    var urlShringTxt =
      apiUrl + "brand/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ brandList: res.data.result });
      }
    });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      productName: postData.productName,
      productbrandID: postData.productbrandID?.value || "",
      productMachineNo: postData.productMachineNo,
      productModleNo: postData.productModleNo,
      productHSNSAC: postData.productHSNSAC,
      productTax: postData.productTax?.value ?? '',
      productStock: postData.productStock,
      productPrice: postData.productPrice,
      amcPrice: postData.amcPrice,
      cmcPrice: postData.cmcPrice,
      productWarrantyPeriod: postData.productWarrantyPeriod?.value || "",
      status:
        Object.keys(postData.status).length > 0 ? postData.status?.value : "A",
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="products" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/products"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            brandList={this.state.brandList}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    productName,
    productbrandID,
    productMachineNo,
    productModleNo,
    productHSNSAC,
    productStock,
    productPrice,
    amcPrice,
    cmcPrice,
    productTax,
    productWarrantyPeriod,
    status,
  } = props.fields;

  return {
    fields: [
      "productName",
      "productbrandID",
      "productMachineNo",
      "productModleNo",
      "productHSNSAC",
      "productStock",
      "productPrice",
      "amcPrice",
      "cmcPrice",
      "productWarrantyPeriod",
      "status",
    ],
    validations: {
      productName: [[isEmpty, productName]],
      productbrandID: [[isSingleSelect, productbrandID]],
      productMachineNo: [[isEmpty, productMachineNo]],
      productModleNo: [[isEmpty, productModleNo]],
      productHSNSAC: [[isEmpty, productHSNSAC]],
      productTax: [[isSingleSelect, productTax]],
      productStock: [[isEmpty, productStock]],
      productPrice: [[isEmpty, productPrice]],
      amcPrice: [[isEmpty, amcPrice]],
      cmcPrice: [[isEmpty, cmcPrice]],
      productWarrantyPeriod: [[isSingleSelect, productWarrantyPeriod]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push("/products");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgproductName,
      errMsgproductbrandID,
      errMsgproductMachineNo,
      errMsgproductModleNo,
      errMsgproductHSNSAC,
      errMsgproductTax,
      errMsgproductStock,
      errMsgproductPrice,
      errMsgamcPrice,
      errMsgcmcPrice,
      errMsgproductWarrantyPeriod,
      errMsgStatus = "";

    if ($validation.productName.error.reason !== undefined) {
      errMsgproductName = $validation.productName.show && (
        <span className="error">{$validation.productName.error.reason}</span>
      );
    }
    if ($validation.productbrandID.error.reason !== undefined) {
      errMsgproductbrandID = $validation.productbrandID.show && (
        <span className="error">{$validation.productbrandID.error.reason}</span>
      );
    }

    if ($validation.productMachineNo.error.reason !== undefined) {
      errMsgproductMachineNo = $validation.productMachineNo.show && (
        <span className="error">
          {$validation.productMachineNo.error.reason}
        </span>
      );
    }
    if ($validation.productModleNo.error.reason !== undefined) {
      errMsgproductModleNo = $validation.productModleNo.show && (
        <span className="error">{$validation.productModleNo.error.reason}</span>
      );
    }
    if ($validation.productHSNSAC.error.reason !== undefined) {
      errMsgproductHSNSAC = $validation.productHSNSAC.show && (
        <span className="error">{$validation.productHSNSAC.error.reason}</span>
      );
    }
    if ($validation.productTax.error.reason !== undefined) {
      errMsgproductTax = $validation.productTax.show && (
        <span className="error">{$validation.productTax.error.reason}</span>
      );
    }

    if ($validation.productStock.error.reason !== undefined) {
      errMsgproductStock = $validation.productStock.show && (
        <span className="error">{$validation.productStock.error.reason}</span>
      );
    }
    if ($validation.productPrice.error.reason !== undefined) {
      errMsgproductPrice = $validation.productPrice.show && (
        <span className="error">{$validation.productPrice.error.reason}</span>
      );
    }
    if ($validation.amcPrice.error.reason !== undefined) {
      errMsgamcPrice = $validation.amcPrice.show && (
        <span className="error">{$validation.amcPrice.error.reason}</span>
      );
    }
    if ($validation.cmcPrice.error.reason !== undefined) {
      errMsgcmcPrice = $validation.cmcPrice.show && (
        <span className="error">{$validation.cmcPrice.error.reason}</span>
      );
    }
    if ($validation.productWarrantyPeriod.error.reason !== undefined) {
      errMsgproductWarrantyPeriod = $validation.productWarrantyPeriod.show && (
        <span className="error">
          {$validation.productWarrantyPeriod.error.reason}
        </span>
      );
    }

    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Product Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Product Name"
                name="productName"
                value={fields.productName}
                {...$field("productName", (e) =>
                  onChange("productName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Brand<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.productbrandID}
                onChange={this.handleSelectChange.bind(this, "productbrandID")}
                placeholder="Select Brand"
                isClearable={true}
                options={this.props.brandList}
              />
              {errMsgproductbrandID}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Machine No<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Machine No"
                name="productMachineNo"
                value={fields.productMachineNo}
                {...$field("productMachineNo", (e) =>
                  onChange("productMachineNo", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductMachineNo}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Modle No<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Modle No"
                name="productModleNo"
                value={fields.productModleNo}
                {...$field("productModleNo", (e) =>
                  onChange("productModleNo", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductModleNo}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                HSN/SAC<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="HSN/SAC"
                name="productHSNSAC"
                value={fields.productHSNSAC}
                {...$field("productHSNSAC", (e) =>
                  onChange("productHSNSAC", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductHSNSAC}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Tax(%)<span className="lbl-error">*</span>
              </label>
             
              <Select
                value={fields.productTax}
                onChange={this.handleSelectChange.bind(
                  this,
                  "productTax"
                )}
                placeholder="Warranty Period"
                isClearable={true}
                options={[
                  {label:'18%', value:'18.00'},
                  {label:'28%', value:'28.00'}
                ]}
              />
              {errMsgproductTax}
              
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Stock<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Stock"
                name="productStock"
                value={fields.productStock}
                {...$field("productStock", (e) =>
                  onChange("productStock", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductStock}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Sale Price<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Sale Price"
                name="productPrice"
                value={fields.productPrice}
                {...$field("productPrice", (e) =>
                  onChange("productPrice", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgproductPrice}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                AMC Price<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="AMC Price"
                name="amcPrice"
                value={fields.amcPrice}
                {...$field("amcPrice", (e) =>
                  onChange("amcPrice", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgamcPrice}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                CMC Price<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="CMC Price"
                name="cmcPrice"
                value={fields.cmcPrice}
                {...$field("cmcPrice", (e) =>
                  onChange("cmcPrice", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcmcPrice}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Warranty Period<span className="lbl-error">*</span>
              </label>

              <Select
                value={fields.productWarrantyPeriod}
                onChange={this.handleSelectChange.bind(
                  this,
                  "productWarrantyPeriod"
                )}
                placeholder="Warranty Period"
                isClearable={true}
                options={Warranty}
              />

              {errMsgproductWarrantyPeriod}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
